export interface PollOption {
  optionId: string;
  label: string;
  order: number;
}

export const POLL_MIN_OPTIONS = 2;
export const POLL_MAX_OPTIONS = 50;

export type PollMode = "standard" | "claim";

export interface PollResultsResponse {
  noticeId: string;
  question: string;
  closesAt?: string;
  isClosed: boolean;
  totalVotes: number;
  options: Array<{
    optionId: string;
    label: string;
    order: number;
    count: number;
    percentage: number;
  }>;
  allOptions?: Array<{
    optionId: string;
    label: string;
    order: number;
    count: number;
    percentage: number;
  }>;
  claimedOptions?: Array<{
    optionId: string;
    label: string;
    order: number;
    claimedAt: string;
    userId: string;
    voterName?: string;
    voterEmail?: string;
  }>;
  pollMode?: PollMode;
  responses: Array<{
    userId: string;
    optionId: string;
    respondedAt: string;
    voterName?: string;
    voterEmail?: string;
    canonicalUserId?: string;
  }>;
  myResponse?: {
    optionId: string;
    respondedAt: string;
  };
}
